import React, { useState } from 'react';
import {
  useInfiniteNotifications,
  useMarkNotificationAsRead,
} from '../../hooks/useNotifications';
import { Notification } from '../molecules/Notifications/Notification';
import classNames from 'classnames';
import { PageTitle } from '../atoms/PageTitle';
import { PageWrapper } from '../atoms/PageWrapper';

export function NotificationsPage() {
  const [read, setRead] = useState(false);

  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    error,
    refetch,
  } = useInfiniteNotifications({ read });

  const { mutate: markAsRead } = useMarkNotificationAsRead();

  return (
    <PageWrapper className="max-w-xl">
      <PageTitle title="Notifications">
        <button onClick={() => refetch()}>Refresh</button>
      </PageTitle>
      <div className="my-2 pl-10 ">
        <div className="my-2 flex rounded-full bg-dl-surface p-1 shadow-sm ring-1 ring-dl-border">
          <button
            onClick={() => setRead(false)}
            className={classNames('flex-1 rounded-full px-4 py-1 transition', {
              'bg-dl-primary text-white': read === false,
              'hover:bg-dl-tint': read !== false,
            })}
          >
            Unread
          </button>
          <button
            onClick={() => setRead(true)}
            className={classNames('flex-1 rounded-full px-4 py-1 transition', {
              'bg-dl-primary text-white': read === true,
              'hover:bg-dl-tint': read !== true,
            })}
          >
            Read
          </button>
          <button
            onClick={() => setRead(undefined)}
            className={classNames('flex-1 rounded-full px-4 py-1 transition', {
              'bg-dl-primary text-white': read === undefined,
              'hover:bg-dl-tint': read !== undefined,
            })}
          >
            All
          </button>
        </div>
        <div
          className={classNames('flex flex-col divide-y rounded-md', {
            border: !!data?.pages,
          })}
        >
          {error && <div>An error occured</div>}
          {!data && <div>Loading...</div>}
          {data?.pages?.map((page, i) => (
            <React.Fragment key={i}>
              {page.content.map(notification => (
                <Notification
                  key={notification.id}
                  notification={notification}
                  variant="long"
                  onRead={() => {
                    markAsRead(notification.id);
                  }}
                  className="px-2 py-1 hover:bg-dl-sunken"
                />
              ))}
            </React.Fragment>
          ))}
        </div>
        {hasNextPage && (
          <div className="flex justify-center">
            <button
              className="my-2 rounded-md px-2 py-1 hover:bg-dl-sunken"
              onClick={() => fetchNextPage()}
              disabled={isFetchingNextPage}
            >
              Load more
            </button>
          </div>
        )}
      </div>
    </PageWrapper>
  );
}
